const LeaveRestrictionTypes = {
	FETCH_LEAVE_RESTRICTIONS_START: 'fetch_leave_restrictions_start',
	FETCH_LEAVE_RESTRICTIONS_SUCCESS: 'fetch_leave_restrictions_success',
	FETCH_LEAVE_RESTRICTIONS_FAILURE: 'fetch_leave_restrictions_failure',
	FETCH_LEAVE_RESTRICTIONS_KEY: 'GetAllRestrictedLeavesFromWeb',
	CREATE_LEAVE_RESTRICTION_START: 'create_leave_restriction_start',
	CREATE_LEAVE_RESTRICTION_SUCCESS: 'create_leave_restriction_success',
	CREATE_LEAVE_RESTRICTION_FAILURE: 'create_leave_restriction_failure',
	CREATE_LEAVE_RESTRICTION_KEY: 'CreateRestrictedLeaveFromWeb',
	UPDATE_LEAVE_RESTRICTION_START: 'update_leave_restriction_start',
	UPDATE_LEAVE_RESTRICTION_SUCCESS: 'update_leave_restriction_success',
	UPDATE_LEAVE_RESTRICTION_FAILURE: 'update_leave_restriction_failure',
	UPDATE_LEAVE_RESTRICTION_KEY: 'UpdateRestrictedLeaveFromWeb',
	DELETE_LEAVE_RESTRICTION_START: 'delete_leave_restriction_start',
	DELETE_LEAVE_RESTRICTION_SUCCESS: 'delete_leave_restriction_success',
	DELETE_LEAVE_RESTRICTION_FAILURE: 'delete_leave_restriction_failure',
	UNPUBLISH_LEAVE_RESTRICTION_START: 'unpublish_leave_restriction_start',
	UNPUBLISH_LEAVE_RESTRICTION_SUCCESS: 'unpublish_leave_restriction_success',
	UNPUBLISH_LEAVE_RESTRICTION_FAILURE: 'unpublish_leave_restriction_failure',
	UNPUBLISH_LEAVE_RESTRICTION_KEY: 'UnpublishRestrictedLeaveFromWeb',
	PUBLISH_LEAVE_RESTRICTION_START: 'publish_leave_restriction_start',
	PUBLISH_LEAVE_RESTRICTION_SUCCESS: 'publish_leave_restriction_success',
	PUBLISH_LEAVE_RESTRICTION_FAILURE: 'publish_leave_restriction_failure',
	PUBLISH_LEAVE_RESTRICTION_KEY: 'PublishRestrictedLeaveFromWeb',
} as const;

export default LeaveRestrictionTypes;
